/* ============================================================
   HERB & HEAL - FOURTH COLLECTION TILE

   "Explore Our Collections" shipped with three tiles in a grid
   that was declaring more columns than it filled. The grid is now
   auto-fit so three tiles share the full width, and this adds a
   fourth so the row reads as a deliberate set rather than a row
   that ran out.

   HONEST NOTE ON THE TARGET
   It points at /collections/all, not at a category, because every
   other collection on the store is either already tiled or empty:
     herbal-powders      1 product   (tiled)
     herbal-supplements  2 products  (tiled)
     herbal-teas         1 product   (tiled)
     wellness-bundles    0 products
     natural-skincare    0 products
     aromatherapy        0 products
   A tile pointing at an empty collection is worse than no tile.
   When Slippery Elm Bark launches, change TILE below to that
   collection - it is one line.

   THIS SHOULD MOVE TO SOURCE
   Merchandising belongs in templates/index.json, not in a script.
   This exists so the row is right today; fold it into the section
   markup on the next pass and delete this file.
   ============================================================ */
(function () {
  'use strict';

  var TILE = {
    label: 'Shop All',
    href: '/collections/all',
    // Same line-icon language as the rest of the site.
    icon: '<path d="M3 8.5 12 4l9 4.5V17L12 21l-9-4V8.5Z"/><path d="M3 8.5 12 13l9-4.5M12 13v8"/>'
  };

  function build() {
    var first = document.querySelector('.hh-cat-tile');
    if (!first) return;

    var grid = first.parentNode;
    if (!grid || grid.querySelector('[data-hh-tile]')) return;

    // Clone tile one so the new tile inherits whatever styling the
    // section already uses - padding, radius, hover, everything.
    var tile = first.cloneNode(true);
    tile.setAttribute('data-hh-tile', '1');

    // Point it at the new destination.
    if (tile.tagName === 'A') {
      tile.setAttribute('href', TILE.href);
    } else {
      var a = tile.querySelector('a');
      if (a) a.setAttribute('href', TILE.href);
      else tile.onclick = function () { window.location.href = TILE.href; };
    }
    tile.style.cursor = 'pointer';

    // Swap the icon. The clone may carry either an emoji (before
    // hh-icons.js runs) or an already-converted <svg>.
    var oldSvg = tile.querySelector('svg');
    var newSvg = '<svg class="hh-icon hh-icon--lg" viewBox="0 0 24 24" aria-hidden="true" ' +
                 'stroke="currentColor" fill="none" stroke-width="1.5" ' +
                 'stroke-linecap="round" stroke-linejoin="round">' + TILE.icon + '</svg>';
    if (oldSvg) {
      oldSvg.outerHTML = newSvg;
    }

    // Replace the label - the deepest element holding real words.
    var best = null;
    var all = tile.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (el.children.length === 0 && el.textContent.trim().length > 1) best = el;
    }
    if (best) {
      best.textContent = TILE.label;
    } else {
      tile.appendChild(document.createTextNode(TILE.label));
    }

    // Strip any emoji the clone still carries in bare text nodes.
    var emoji = /[☀-➿⬀-⯿️]|[\uD83C-\uD83E][\uDC00-\uDFFF]/g;
    var w = document.createTreeWalker(tile, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = w.nextNode())) {
      if (emoji.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(emoji, '');
    }

    grid.appendChild(tile);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build, { once: true });
  } else {
    build();
  }
})();
